import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors except 408, 429
        const status = (error as { status?: number })?.status
        if (status != null && status >= 400 && status < 500 && ![408, 429].includes(status)) {
          return false
        }
        // Don't retry PostgrestErrors (RLS denials, plan-limit P0001, PGRST*, etc.)
        // — PostgrestError exposes `code` (SQLSTATE), not `status`.
        const pgCode = (error as { code?: string })?.code
        if (pgCode != null) return false
        return failureCount < 3
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors
        const status = (error as { status?: number })?.status
        if (status != null && status >= 400 && status < 500) {
          return false
        }
        // Don't retry any PostgrestError on mutations either
        const pgCode = (error as { code?: string })?.code
        if (pgCode != null) return false
        return failureCount < 2
      },
    },
  },
})